import ProgressivesApi from '../../../../../api/ProgressivesApi';
import _ from 'lodash';

/**
 *
 * @param
 * @returns {function(*): Promise<unknown>}
 */
export function getList() {
   return ProgressivesApi.getList()
      .then(response => {
         if (response.data.success === true) {
            response.data.data.forEach(el => {
               el.key = el.id;
            });
            return response.data;
         }
         else
            throw new Error(response.data.error ? response.data.error : 'Server error');
      })
      .catch(error => {
         throw error;
      });
}

export function getListExtended(params = [], filterValues = {}) {
   return ProgressivesApi.getListExtended(params, filterValues)
      .then(response => {
         if (response.data.success === true) {
            response.data.data.data.forEach(el => {
               el.key = el.id;
            });
            // console.log(response);
            return response.data;
         }
         else
            throw new Error(response.data.error ? response.data.error : 'Server error');
      })
      .catch(error => {
         throw error;
      });
}

/**
 *
 * @param
 * @returns {function(*): Promise<unknown>}
 */
export function getComplements() {
   return ProgressivesApi.getComplements()
      .then(response => {
         console.log(response);
         const responseData = {}
         _.forEach(response, (el, i) => {
            if (el.data.success !== true) {
               const error = el.data.error ? el.data.error : 'Server error'
               throw new Error(error)
            }
            responseData[i] = el.data.data;
         });
         return responseData;
      })
      .catch(error => {
         throw error;
      });
}

export function getModel() {
   return ProgressivesApi.getModel()
      .then(response => {
         if (response.data.success === true) {
            return response.data;
         }
         else
            throw new Error(response.data.error ? response.data.error : 'Server error');
      })
      .catch(error => {
         throw error;
      });
}
export function getItem(itemId, params = [], filterValues = {}) {
   return ProgressivesApi.getItem(itemId, params, filterValues)
      .then(response => {
         if (response.data.success === true) {
            // console.log(response);
            return response.data;
         }
         else
            throw new Error(response.data.error ? response.data.error : 'Server error');
      })
      .catch(error => {
         throw error;
      });
}

/**
 *
 * @param
 * @returns {function(*): Promise<unknown>}
 */
export function createOrUpdate(itemData) {
   console.log(itemData);
   return ProgressivesApi.createOrUpdate(itemData)
      .then(response => {
         if (response.data.success === true) {
            // console.log(response);
            return response.data;
         }
         else
            throw new Error(response.data.error ? response.data.error : 'Server error');
      })
      .catch(error => {
         throw error;
      });
}

export function duplicateItem(itemId, onlyMissing) {
   return ProgressivesApi.duplicateItem(itemId, onlyMissing)
      .then(response => {
         console.log(response);
         let blob = new Blob([response.data], { type: 'application/*' })
         let link = document.createElement('a')
         link.href = window.URL.createObjectURL(blob)
         link.download = 'duplicate.xlsx';
         link.click();
         return true;
      })
      .catch(error => {
         throw error;
      })
}
export function duplicateItemsAndSearch(itemIds, onlyMissing) {
   return ProgressivesApi.duplicateItemsAndSearch(itemIds, onlyMissing)
      .then(response => {
         console.log(response);
         let blob = new Blob([response.data], { type: 'application/*' })
         let link = document.createElement('a')
         link.href = window.URL.createObjectURL(blob)
         link.download = 'duplicate.zip';
         link.click();
         return true;
      })
      .catch(error => {
         throw error;
      })
}
export function confirmItems(itemIds, return_list = false) {
   return ProgressivesApi.confirmItems(itemIds, return_list)
      .then(response => {
         if (response.data.success === true) {
            return response.data;
         }
         else
            throw new Error(response.data.error ? response.data.error : 'Server error');
      })
      .catch(error => {
         throw error;
      });
}
export function cancelItems(itemIds, return_list = false) {
   return ProgressivesApi.cancelItems(itemIds, return_list)
      .then(response => {
         if (response.data.success === true) {
            return response.data;
         }
         else
            throw new Error(response.data.error ? response.data.error : 'Server error');
      })
      .catch(error => {
         throw error;
      });
}
export function restoreItems(itemIds, return_list = false) {
   return ProgressivesApi.restoreItems(itemIds, return_list)
      .then(response => {
         if (response.data.success === true) {
            return response.data;
         }
         else
            throw new Error(response.data.error ? response.data.error : 'Server error');
      })
      .catch(error => {
         throw error;
      });
}
export function deleteItems(itemIds, return_list = false) {
   return ProgressivesApi.deleteItems(itemIds, return_list)
      .then(response => {
         if (response.data.success === true) {
            return response.data;
         }
         else
            throw new Error(response.data.error ? response.data.error : 'Server error');
      })
      .catch(error => {
         throw error;
      });
}
export function mergeItems(itemIds, return_list = false) {
   return ProgressivesApi.mergeItems(itemIds, return_list)
      .then(response => {
         console.log(response);
         let blob = new Blob([response.data], { type: 'application/*' })
         let link = document.createElement('a')
         link.href = window.URL.createObjectURL(blob)
         link.download = 'merge.xlsx';
         link.click();
         return true;
      })
      .catch(error => {
         throw error;
      })
}

export function sendToAmazon(itemId) {
   return ProgressivesApi.sendToAmazon(itemId)
      .then(response => {
         if (response.data.success === true) {
            return response.data;
         }
         else
            throw new Error(response.data.error ? response.data.error : 'Server error');
      })
      .catch(error => {
         throw error;
      });
}

export function importFromFile(formData) {
   return ProgressivesApi.importFromFile(formData)
      .then(response => {
         if (response.data.success === true) {
            return response.data;
         }
         else
            throw new Error(response.data.error ? response.data.error : 'Server error');
      })
      .catch(error => {
         throw error;
      });
}

export function fileImport(data) {
   const { onSuccess, onError, file, onProgress } = data;
   return ProgressivesApi.fileImport(data)
      .then(response => {
         if (response.data.success === true) {
            // return {
            //    file: data.file,
            //    result: response.data
            // }
            onSuccess(response.data)
         }
         else {
            // return {
            //    err: response.data.error ? response.data.error : 'Server error',
            //    response: response.data,
            //    file: data.file
            // }
            const error = new Error(response.data.error ? response.data.error : 'Server error')
            onError({ event: error })
         }
      })
      .catch(error => {
         console.log(error)
         onError({ event: error })
      });
}

export function exportExcel(filename, itemIds) {
   return ProgressivesApi.exportExcel(filename, itemIds)
      .then(response => {
         let blob = new Blob([response.data], { type: 'application/*' })
         let link = document.createElement('a')
         link.href = window.URL.createObjectURL(blob)
         link.download = filename;
         link.click();
      })
      .catch(error => {
         throw error;
      });
}

export function exportDetails(filename, itemIds) {
   return ProgressivesApi.exportDetails(filename, itemIds)
      .then(response => {
         let blob = new Blob([response.data], { type: 'application/*' })
         let link = document.createElement('a')
         link.href = window.URL.createObjectURL(blob)
         link.download = filename;
         link.click();
      })
      .catch(error => {
         throw error;
      });
}